import React, { useState } from "react";
import axios from "axios";
import API_BASE_URL from "../../config";
import "./MacLookup.css";

const MacLookup = () => {
  const [mac, setMac] = useState("");
  const [vendor, setVendor] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // 🧠 Helper: Clean MAC input
  const cleanMacInput = (input) => {
    return input.replace(/[^A-Fa-f0-9]/g, "").toUpperCase();
  };

  const handleLookup = async () => {
    if (!mac.trim()) {
      setError("⚠️ Please enter a MAC address before searching.");
      return;
    }

    setError("");
    setVendor("");
    setLoading(true);

    try {
      const cleaned = cleanMacInput(mac);

      if (cleaned.length < 4) {
        setError("❌ MAC input too short. Minimum 4 hex digits required.");
        setLoading(false);
        return;
      }

      const encodedMac = encodeURIComponent(mac);

      // ✅ BASE URL ADDED HERE
      const response = await axios.get(
        `${API_BASE_URL}/diagnostic-tools/mac-lookup?mac=${encodedMac}`
      );

      if (response.data.vendor) {
        setVendor(response.data.vendor);

      } else if (response.data.error) {
        setError(`❌ ${response.data.error}`);

      } else {
        setError("❌ No vendor found for this MAC input.");
      }

    } catch (err) {
      console.error("MAC Lookup Error:", err);
      setError("❌ Could not reach MAC vendor service. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mac-lookup">

      <h3>💻 MAC Lookup Tool</h3>

      <div className="mac-input-group">
        <input
          type="text"
          placeholder="Enter MAC (any format e.g. 78:44:76:B5:5F:C1)"
          value={mac}
          onChange={(e) => setMac(e.target.value)}
        />

        <button onClick={handleLookup} disabled={loading}>
          {loading ? "Searching..." : "MAC Lookup"}
        </button>
      </div>

      {error && <p className="error-box">{error}</p>}

      {vendor && (
        <div className="result-box">
          <h4>✅ Vendor Found</h4>
          <p><strong>{vendor}</strong></p>
        </div>
      )}

    </div>
  );
};

export default MacLookup;